module.exports = __webpack_public_path__ + "images/ca88b279dfff24548ea41fa12fa6590a.png";